var variantPrices = [];
// Money Format
var Shopify = Shopify || {};

Shopify.money_format = window.cartStrings.money_format || "{{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.', ''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};



// Featured Collection with tabbing Functionality.
const tabbingProductsCache = new Map();

function getTabbingCacheKey(tabContent, collectionHandle, tag) {
  const sectionId = tabContent.dataset.ajaxSectionId || '';
  const tabIndex = tabContent.dataset.tabIndex || '';
  return `${sectionId}::${tabIndex}::${collectionHandle}::${tag}`;
}

function getTabbingProductsMount(tabContent) {
  return tabContent?.querySelector('.js-tabbing-products-mount');
}

function getTabbingActiveTagElement(tabContent) {
  return tabContent?.querySelector('.js_featured_tab_product_tag.is--active');
}

function buildTabbingFetchUrl(tabContent, collectionHandle, tag, isAllProducts) {
  const ajaxSectionId = tabContent.dataset.ajaxSectionId;
  const tabbingManagement = tabContent.dataset.tabbingManagement;
  const parentHandle = tabContent.dataset.parentCollectionHandle;
  const root = window.Shopify?.routes?.root || '/';

  const wantsAllProducts = isAllProducts || !tag || tag === 'all-products' || tag === 'all-product';
  if (tabbingManagement === 'tags' && !wantsAllProducts) {
    return `${root}collections/${parentHandle}/${tag}?section_id=${ajaxSectionId}`;
  }

  return `${root}collections/${collectionHandle}?section_id=${ajaxSectionId}`;
}

function extractTabbingProductsMarkup(html) {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const ajaxProducts = doc.querySelector('.js-tabbing-ajax-products');
  if (ajaxProducts) return ajaxProducts.innerHTML;
  const mount = doc.querySelector('.js-tabbing-products-mount');
  if (mount) return mount.innerHTML;
  return '';
}

function bindTabbingProductGrid(mount) {
  if (!mount) return;
  // Ajax markup carries the ajax section's padding class; use the tab section's one
  // so the spacing between the sub-category buttons and the cards stays identical.
  const paddingClass = mount.dataset.paddingClass;
  if (paddingClass) {
    mount.querySelectorAll('.collection').forEach((el) => {
      Array.from(el.classList)
        .filter((cls) => /^section-.+-padding$/.test(cls) && cls !== paddingClass)
        .forEach((cls) => el.classList.remove(cls));
      el.classList.add(paddingClass);
    });
  }
  if (typeof window.updateColorSwatches === 'function') {
    window.updateColorSwatches();
  }
  mount.querySelectorAll('slider-component').forEach((slider) => {
    if (typeof slider.initPages === 'function') {
      slider.initPages();
    }
  });
  if (typeof initializeScrollAnimationTrigger === 'function') {
    initializeScrollAnimationTrigger(mount);
  }
}

function setTabbingMountLoading(mount, isLoading) {
  if (!mount) return;
  mount.classList.toggle('is-loading', isLoading);
  const tabContent = mount.closest('.js_featured_collection_tab_content');
  const spinner = (tabContent || mount).querySelector('.tabbing-products-mount__loading');
  if (spinner) {
    spinner.classList.toggle('hidden', !isLoading);
  }
}

const tabbingProductsInflight = new Map();

// Fetches the markup for one sub-category into the cache. Shared by the
// click path and the prefetch path so a hover followed by a click never
// triggers two requests.
function fetchTabbingMarkup(tabContent, collectionHandle, tag, isAllProducts, options = {}) {
  const cacheKey = getTabbingCacheKey(tabContent, collectionHandle, tag || 'all-products');
  if (!options.forceFetch && tabbingProductsCache.has(cacheKey)) {
    return Promise.resolve(tabbingProductsCache.get(cacheKey));
  }
  if (tabbingProductsInflight.has(cacheKey)) {
    return tabbingProductsInflight.get(cacheKey);
  }
  const fetchUrl = buildTabbingFetchUrl(tabContent, collectionHandle, tag, isAllProducts);
  const request = fetch(fetchUrl, { priority: options.prefetch ? 'low' : 'auto' })
    .then((response) => {
      if (!response.ok) throw new Error(`Tabbing products request failed: ${response.status}`);
      return response.text();
    })
    .then((html) => {
      const markup = extractTabbingProductsMarkup(html);
      if (markup) tabbingProductsCache.set(cacheKey, markup);
      return markup;
    })
    .finally(() => {
      tabbingProductsInflight.delete(cacheKey);
    });
  tabbingProductsInflight.set(cacheKey, request);
  return request;
}

// Warm the cache for a sub-category without touching the visible grid.
function prefetchTabbingProducts(tabContent, tagElement) {
  if (!tabContent || !getTabbingProductsMount(tabContent)) return Promise.resolve();
  if (navigator.connection && navigator.connection.saveData) return Promise.resolve();
  const tagEle = tagElement || getTabbingActiveTagElement(tabContent);
  const collectionHandle = tagEle?.dataset.collectionHandle || tabContent.dataset.parentCollectionHandle;
  if (!collectionHandle) return Promise.resolve();
  const tag = tagEle?.dataset.tag || 'all-products';
  const isAllProducts = tagEle?.dataset.isAllProducts === 'true';
  return fetchTabbingMarkup(tabContent, collectionHandle, tag, isAllProducts, { prefetch: true }).catch(() => {});
}

function loadTabbingProducts(tabContent, collectionHandle, tag, isAllProducts, options = {}) {
  const mount = getTabbingProductsMount(tabContent);
  if (!mount || !collectionHandle) return Promise.resolve();

  const cacheKey = getTabbingCacheKey(tabContent, collectionHandle, tag || 'all-products');
  const requestId = `${Date.now()}-${Math.random()}`;
  mount.dataset.pendingRequestId = requestId;

  if (!options.forceFetch && tabbingProductsCache.has(cacheKey)) {
    mount.innerHTML = tabbingProductsCache.get(cacheKey);
    mount.dataset.loaded = 'true';
    mount.dataset.activeTag = tag || 'all-products';
    mount.dataset.activeCollection = collectionHandle;
    bindTabbingProductGrid(mount);
    return Promise.resolve();
  }

  if (mount.dataset.loaded === 'true' && !options.forceFetch) {
    const currentTag = mount.dataset.activeTag;
    const currentCollection = mount.dataset.activeCollection;
    if (currentTag === (tag || 'all-products') && currentCollection === collectionHandle) {
      return Promise.resolve();
    }
  }

  setTabbingMountLoading(mount, true);

  return fetchTabbingMarkup(tabContent, collectionHandle, tag, isAllProducts, options)
    .then((markup) => {
      if (mount.dataset.pendingRequestId !== requestId) return;
      if (!markup) return;
      mount.innerHTML = markup;
      mount.dataset.loaded = 'true';
      mount.dataset.activeTag = tag || 'all-products';
      mount.dataset.activeCollection = collectionHandle;
      bindTabbingProductGrid(mount);
    })
    .catch((error) => {
      console.error('Featured collection tabbing load failed:', error);
    })
    .finally(() => {
      if (mount.dataset.pendingRequestId === requestId) {
        setTabbingMountLoading(mount, false);
      }
    });
}

function ensureTabContentProducts(tabContent, options = {}) {
  if (!tabContent) return Promise.resolve();
  const mount = getTabbingProductsMount(tabContent);
  if (!mount) return Promise.resolve();

  if (mount.dataset.loaded === 'true' && mount.children.length > 0 && !options.forceReload) {
    return Promise.resolve();
  }

  const activeTagElement = getTabbingActiveTagElement(tabContent);
  const collectionHandle =
    activeTagElement?.dataset.collectionHandle || tabContent.dataset.parentCollectionHandle;
  const tag = activeTagElement?.dataset.tag || 'all-products';
  const isAllProducts = activeTagElement?.dataset.isAllProducts === 'true';

  return loadTabbingProducts(tabContent, collectionHandle, tag, isAllProducts, options);
}

function bindTabbingPrefetch(element, getTarget) {
  let armed = true;
  const trigger = () => {
    if (!armed) return;
    armed = false;
    const target = getTarget();
    if (target) prefetchTabbingProducts(target.tabContent, target.tagElement);
  };
  ['pointerenter', 'touchstart', 'focus'].forEach((eventName) => {
    element.addEventListener(eventName, trigger, { passive: true });
  });
}

function scheduleIdleTabbingPrefetch(featuredCollection) {
  const tabContents = Array.from(featuredCollection.querySelectorAll('.js_featured_collection_tab_content'));
  const pending = tabContents.filter((tabContent) => {
    const mount = getTabbingProductsMount(tabContent);
    return mount && mount.dataset.loaded !== 'true';
  });
  if (pending.length === 0) return;

  const run = () => {
    // One tab after the other, so the prefetch never competes with itself.
    pending.reduce(
      (chain, tabContent) => chain.then(() => prefetchTabbingProducts(tabContent)),
      Promise.resolve()
    );
  };
  const idle = window.requestIdleCallback || ((cb) => setTimeout(cb, 1500));
  const start = () => idle(run, { timeout: 4000 });

  if (!('IntersectionObserver' in window)) {
    window.addEventListener('load', start, { once: true });
    return;
  }
  const observer = new IntersectionObserver(
    (entries) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        observer.disconnect();
        start();
      }
    },
    { rootMargin: '400px 0px' }
  );
  observer.observe(featuredCollection);
}

const FeaturedCollectionTabbings = document.querySelectorAll('.feaured-collection-with-tabbings');
if(FeaturedCollectionTabbings.length > 0){
  FeaturedCollectionTabbings.forEach(featured_collection=>{
    const AllTabs = featured_collection.querySelectorAll('.js_featured_collection_tab_heaidng');
    if(AllTabs.length > 0){
      AllTabs.forEach((tab, index)=>{
        tab.addEventListener('click', ()=>{
          HandleTabContent(tab, featured_collection, index);
        })
        bindTabbingPrefetch(tab, () => {
          const tabContent = featured_collection.querySelector(`#tab_content_${index}`);
          return tabContent ? { tabContent, tagElement: null } : null;
        });
      })
    }
    scheduleIdleTabbingPrefetch(featured_collection);
  })
}

const FeaturedCollectionTagsEle = document.querySelectorAll('.js_featured_collection_tabs_products_tags');
if(FeaturedCollectionTagsEle.length > 0){
  FeaturedCollectionTagsEle.forEach(ele=>{
    const AllTagsEle = ele.querySelectorAll('.js_featured_tab_product_tag');
    if(AllTagsEle.length > 0){
      AllTagsEle.forEach(tag_ele=>{
        tag_ele.addEventListener('click',()=>{
          HandleTagContent(tag_ele);
        })
        bindTabbingPrefetch(tag_ele, () => {
          const tabContent = tag_ele.closest('.js_featured_collection_tab_content');
          return tabContent ? { tabContent, tagElement: tag_ele } : null;
        });
      })
    }
  })  
}

function filterTabbingProductsByTag(tabContent, tag){
  // Fallback for sections that still render every sub-category server-side:
  // show only the cards whose data-product-tags contain the active tag.
  tabContent.querySelectorAll('.grid__item').forEach((product) => {
    if (!tag) {
      product.classList.remove('hidden');
      return;
    }
    const tags = (product.getAttribute('data-product-tags') || '').split(',');
    product.classList.toggle('hidden', !tags.includes(tag));
  });
}

function HandleTagContent(currentTarget){
  const tabContent = currentTarget.closest('.js_featured_collection_tab_content');
  if (!tabContent) return;

  // Same toggle behaviour as the live theme: clicking the active tag
  // deactivates it and shows every product again.
  const wasActive = currentTarget.classList.contains('is--active');
  const hasMount = Boolean(getTabbingProductsMount(tabContent));

  // Ajax mode: one sub-category is always active, clicking it again is a no-op.
  if (hasMount && wasActive) return;

  tabContent.querySelectorAll('.js_featured_tab_product_tag').forEach((tagEle) => {
    tagEle.classList.toggle('is--active', tagEle === currentTarget && !wasActive);
  });
  const isActive = !wasActive;

  if (!hasMount) {
    filterTabbingProductsByTag(tabContent, isActive ? currentTarget.dataset.tag : null);
    return;
  }

  if (!isActive) {
    return;
  }

  const collectionHandle = currentTarget.dataset.collectionHandle || tabContent.dataset.parentCollectionHandle;
  const tag = currentTarget.dataset.tag || 'all-products';
  const isAllProducts = currentTarget.dataset.isAllProducts === 'true';

  loadTabbingProducts(tabContent, collectionHandle, tag, isAllProducts);
}

function HandleTabContent(currentTarget, ParentElement, index){
  const allTabs = ParentElement.querySelectorAll('.js_featured_collection_tab_heaidng');
  if(allTabs.length > 0){
    allTabs.forEach(tab=>{
      if(tab.classList.contains('is--selected')) tab.classList.remove('is--selected');
    });
  }

  const tabContents = ParentElement.querySelectorAll('.js_featured_collection_tab_content');
  if(tabContents.length > 0){
    tabContents.forEach(tabContent=>{
      if(tabContent.classList.contains('is--selected')) tabContent.classList.remove('is--selected');
    })
  }
  const selectedTabContent = ParentElement.querySelector(`#tab_content_${index}`);
  if(selectedTabContent){
    selectedTabContent.classList.add('is--selected');
    ensureTabContentProducts(selectedTabContent);
  }
  currentTarget.classList.add('is--selected');
  window.initOrDestroyTabbingSlider();
}

// PERF-09: header search recommendations are fetched once, on demand.
const SEARCH_RECOMMENDATIONS_SECTION = 'header-search-recommendations';
let searchRecommendationsRequest = null;

function fetchSearchRecommendations() {
  if (searchRecommendationsRequest) return searchRecommendationsRequest;
  const root = window.Shopify?.routes?.root || '/';
  searchRecommendationsRequest = fetch(`${root}search?section_id=${SEARCH_RECOMMENDATIONS_SECTION}`)
    .then((response) => {
      if (!response.ok) throw new Error(`Search recommendations request failed: ${response.status}`);
      return response.text();
    })
    .then((html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const source = doc.querySelector('.js-search-recommendations-source');
      return source ? source.innerHTML : '';
    })
    .catch((error) => {
      searchRecommendationsRequest = null;
      console.error('Header search recommendations failed:', error);
      return '';
    });
  return searchRecommendationsRequest;
}

function fillSearchRecommendations() {
  const mounts = document.querySelectorAll('.js-search-recommendations:not([data-loaded="true"])');
  if (mounts.length === 0) return Promise.resolve();
  return fetchSearchRecommendations().then((markup) => {
    if (!markup) return;
    mounts.forEach((mount) => {
      mount.innerHTML = markup;
      mount.dataset.loaded = 'true';
    });
    if (typeof window.updateColorSwatches === 'function') window.updateColorSwatches();
  });
}

// Header search panel (mobile fixes): the panel could only be closed by
// tapping the reset button, which is hidden while the field is empty, and it
// opened off-screen when the page was scrolled. Close on outside tap / Escape,
// and bring the header into view when the field gets focus on small screens.
function closeHeaderSearchPanel(searchEl) {
  if (!searchEl) return;
  const wrapper = searchEl.querySelector('.cs_header_predictive_search_wrapper');
  const field = searchEl.querySelector('.field');
  const input = searchEl.querySelector('input[type="search"]');
  if (wrapper) { wrapper.classList.remove('is-active'); wrapper.classList.remove('cs-container-border'); }
  if (field) { field.classList.remove('is-active'); field.classList.remove('already-opened'); }
  if (input && document.activeElement === input) input.blur();
}
function activeHeaderSearchPanels() {
  return Array.from(document.querySelectorAll('.header__search predictive-search, .header__search search-form'))
    .filter((el) => el.querySelector('.cs_header_predictive_search_wrapper.is-active'));
}
document.addEventListener('pointerdown', (event) => {
  activeHeaderSearchPanels().forEach((searchEl) => {
    if (!searchEl.contains(event.target)) closeHeaderSearchPanel(searchEl);
  });
}, true);
// The reset X: Dawn's form reset re-focuses the input, which re-opened the
// panel right after closeout() closed it. Handle the X ourselves instead.
document.addEventListener('click', (event) => {
  const reset = event.target.closest && event.target.closest('.header__search .reset__button');
  if (!reset) return;
  event.preventDefault();
  event.stopPropagation();
  const searchEl = reset.closest('predictive-search, search-form');
  const input = searchEl && searchEl.querySelector('input[type="search"]');
  if (input) input.value = '';
  if (searchEl && typeof searchEl.close === 'function') { try { searchEl.close(true); } catch (e) {} }
  if (searchEl) { searchEl.searchTerm = ''; searchEl.querySelector('#predictive-search-results-groups-wrapper')?.remove(); searchEl.removeAttribute('results'); searchEl.removeAttribute('open'); }
  reset.classList.add('hidden');
  const reco = searchEl && searchEl.querySelector('.cs_custom_recommended_products'); if (reco) reco.classList.remove('is-hidden');
  const cat = searchEl && searchEl.querySelector('.cs_custom_search_bar_category'); if (cat) cat.classList.remove('is-hidden');
  closeHeaderSearchPanel(searchEl);
}, true);
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') activeHeaderSearchPanels().forEach(closeHeaderSearchPanel);
});
// On phones the panel is fixed to the screen right below the search field
// (see custom.css), so it is visible wherever the page is scrolled, including
// when the sticky header is shown mid-page. Tell CSS where the field ends.
function positionHeaderSearchPanel(input) {
  const searchEl = input.closest('predictive-search, search-form');
  const wrapper = searchEl && searchEl.querySelector('.cs_header_predictive_search_wrapper');
  const field = input.closest('.field') || input;
  if (!wrapper) return;
  wrapper.style.setProperty('--search-panel-top', `${Math.max(0, Math.round(field.getBoundingClientRect().bottom))}px`);
}
document.addEventListener('focusin', (event) => {
  if (!event.target.matches || !event.target.matches('.header__search input[type="search"]')) return;
  positionHeaderSearchPanel(event.target);
});
window.addEventListener('resize', () => {
  const input = document.activeElement;
  if (input && input.matches && input.matches('.header__search input[type="search"]')) positionHeaderSearchPanel(input);
});

if (document.querySelector('.js-search-recommendations')) {
  // Opening any header search modal (desktop icon, mobile bar) fills the mounts.
  document.addEventListener('toggle', (event) => {
    const details = event.target;
    if (details.tagName === 'DETAILS' && details.open && details.closest('.header__search')) {
      fillSearchRecommendations();
    }
  }, true);
  // Typing into a search field that is not inside a <details> (inline mobile bar).
  document.addEventListener('focusin', (event) => {
    if (event.target.matches && event.target.matches('.header__search input[type="search"]')) {
      fillSearchRecommendations();
    }
  });
  // Warm the cache as soon as the visitor shows intent (hover / touch on the search field area).
  document.querySelectorAll('.header__search').forEach((area) => {
    ['pointerenter', 'touchstart'].forEach((eventName) => {
      area.addEventListener(eventName, () => fetchSearchRecommendations(), { passive: true, once: true });
    });
  });
}

// Update color swatch variant ID
// Card swatches (PERF-05) are handled by one delegated listener, so they work
// in every card no matter when it was inserted (ajax tabs, search, filters,
// recommendations, theme editor reloads) without re-binding.
if (!window.__cardSwatchDelegationBound) {
  window.__cardSwatchDelegationBound = true;
  document.addEventListener('click', function (event) {
    const swatch = event.target.closest && event.target.closest('.card-product-swatches .cs_featured_collection_color_swatch');
    if (!swatch) return;
    event.preventDefault();
    updateColorSwatchVariant(swatch, event);
  });
}

window.updateColorSwatches = function(){

  const allVariantSelects = document.querySelectorAll('variant-selects-swatches, variant-selects');
  if(allVariantSelects.length > 0){
    allVariantSelects.forEach(fieldset=>{
      const AllInputs = fieldset.querySelectorAll('label');
      if(AllInputs.length > 0){
        AllInputs.forEach(label=>{
          if(label.dataset.swatchClickBound === 'true') return;
          label.dataset.swatchClickBound = 'true';
          label.addEventListener('click', function(event){
            updateColorSwatchVariant(label, event);
          })
        })
      }
      const AllSelectTags = fieldset.querySelectorAll('select');
      if(AllSelectTags.length > 0){
        AllSelectTags.forEach(select=>{
          if(select.dataset.swatchChangeBound === 'true') return;
          select.dataset.swatchChangeBound = 'true';
          select.addEventListener('change', function(event){
            updateColorSwatchVariant(select, event);
          })
        })
      }
    })
  }
}
window.updateColorSwatches();

// Card swatches carry the preview image as a single URL + intrinsic width
// (data-preview-src / data-preview-width) instead of a full srcset string.
// Rebuild the same srcset the card image uses.
const CARD_PREVIEW_WIDTHS = [165, 360, 533, 720, 940, 1066];
function getSwatchPreviewSrcset(swatch) {
  const explicit = swatch.getAttribute('data-preview-image');
  if (explicit) return explicit;
  const src = swatch.getAttribute('data-preview-src');
  if (!src) return '';
  const intrinsic = parseInt(swatch.getAttribute('data-preview-width'), 10) || 0;
  const separator = src.includes('?') ? '&' : '?';
  const candidates = CARD_PREVIEW_WIDTHS
    .filter((w) => !intrinsic || intrinsic >= w)
    .map((w) => `${src}${separator}width=${w} ${w}w`);
  if (intrinsic) candidates.push(`${src} ${intrinsic}w`);
  return candidates.join(',');
}

function updateColorSwatchVariant(currentTarget, event){
  if (
    currentTarget.classList.contains('cs_featured_collection_color_swatch') &&
    currentTarget.closest('.card-product-swatches')
  ) {
    if (currentTarget.classList.contains('is-unavailable')) return;
    const swatchContainer = currentTarget.closest('.card-product-swatches');
    swatchContainer.querySelectorAll('.cs_featured_collection_color_swatch').forEach((swatch) => {
      swatch.classList.remove('is-selected');
      swatch.setAttribute('aria-pressed', 'false');
    });
    currentTarget.classList.add('is-selected');
    currentTarget.setAttribute('aria-pressed', 'true');

    const closestContainer = currentTarget.closest('.product-card-wrapper');
    if (closestContainer) {
      const currentImageWrapper = closestContainer.querySelector('.card__media');
      if (currentImageWrapper) {
        const imgTag = currentImageWrapper.querySelector('img');
        if (imgTag) {
          const selected_variant_preview_srcset_image = getSwatchPreviewSrcset(currentTarget);
          if (selected_variant_preview_srcset_image) {
            imgTag.setAttribute('srcset', selected_variant_preview_srcset_image);
          }
        }
      }
      updateCardSwatchSelection(closestContainer, currentTarget);
    }
    return;
  }

  if(currentTarget.tagName === 'LABEL'){
    const closestFieldset = currentTarget.closest('fieldset');
    if(!closestFieldset) return;

    const label_for = currentTarget.getAttribute('for');
    // Image-picker labels nest the input (no `for` attribute); fall back to input inside label
    const relatedInput = label_for
      ? closestFieldset.querySelector(`input[type="radio"]#${CSS.escape(label_for)}`)
      : currentTarget.querySelector('input[type="radio"]');
    if(!relatedInput) return;

    const AllInputField = closestFieldset.querySelectorAll('input[type="radio"]');
    if(AllInputField.length > 0){
      AllInputField.forEach(_input=>{
        _input.checked = false;
        _input.removeAttribute('checked');
      });
    }
    relatedInput.checked = true;
    relatedInput.setAttribute('checked', '');
    relatedInput.dispatchEvent(new Event('change', { bubbles: true }));

    var closestContainer = '';
    var closestMainContainer = '';
    if(currentTarget.closest('.quick-buy-drawer__info')){
      closestContainer = currentTarget.closest('.quick-buy-drawer__info');
      closestMainContainer = currentTarget.closest('.js-quick-add-content');
    }else if(currentTarget.closest('.product-card-wrapper')){
      closestContainer = currentTarget.closest('.product-card-wrapper');
    }
  
    if(closestContainer){
      var currentImageWrapper = '';
      if(currentTarget.closest('.quick-buy-drawer__info')){
        currentImageWrapper = closestMainContainer?.querySelector('variant-media');
      } else{
        currentImageWrapper = closestContainer?.querySelector('.card__media');
      }
      if(currentImageWrapper){
        const imgTag = currentImageWrapper.querySelector('img');
        if(imgTag){
          const selected_variant_preview_srcset_image = relatedInput.getAttribute('data-preview-image');
          if(selected_variant_preview_srcset_image){
            imgTag.setAttribute('srcset', selected_variant_preview_srcset_image);
          }
        }
      }
      getAllCheckedInputs(closestContainer, event);
    }
  }
  else if(currentTarget.tagName === 'SELECT'){
    const closestFieldset = currentTarget.closest('.product-card-wrapper');
    if(closestFieldset) getAllCheckedInputs(closestFieldset, event);
  }
}

// Quick buy (quick-add modal): buy-buttons.liquid renders the cart button for the variant the modal opened
// with, and option changes only swapped the hidden variant id. The button therefore kept "Ausverkauft"
// after switching to an available size (and stayed active after switching to a sold-out one).
// Only acts inside .js-quick-add-content; product cards keep their behaviour.
// variant: entry from .all_variant_json, or undefined when the option combination does not exist.
function updateQuickBuyButton(container, variant) {
  if (!container || !container.closest('.js-quick-add-content')) return;
  const productForm = container.querySelector('product-form');
  if (!productForm || !productForm.submitButton) return;

  const state = !variant ? 'unavailable' : variant.available ? 'add' : 'sold-out';

  // "Ausverkauft" badge next to the price (snippets/price.liquid shows it via .price--sold-out).
  // Only the badge follows the variant; price and compare-at price stay as rendered.
  const price = container.closest('.js-quick-add-content').querySelector('.product_price_main .price');
  if (price) price.classList.toggle('price--sold-out', state === 'sold-out');

  // With feat/pdp-back-in-stock the button carries every label and setButtonState() switches between them;
  // its toggleSubmitButton() then only disables and would leave a greyed-out "In den Warenkorb".
  if (typeof productForm.setButtonState === 'function' && productForm.submitButton.dataset.buttonState) {
    productForm.setButtonState(state, state !== 'add');
    return;
  }

  // Current live theme: toggleSubmitButton() writes the (Weglot-translated) window.variantStrings text.
  if (state === 'add') {
    productForm.toggleSubmitButton(false);
  } else {
    productForm.toggleSubmitButton(
      true,
      state === 'sold-out' ? window.variantStrings.soldOut : window.variantStrings.unavailable
    );
  }
}

function findVariantInContainer(container, variantId) {
  const allVariantJson = container.querySelector('.all_variant_json');
  if (!allVariantJson) return undefined;
  return JSON.parse(allVariantJson.textContent).find((variant) => String(variant.id) === String(variantId));
}

function updateCardSwatchSelection(closestContainer, selectedSwatch) {
  const selected_variant_id = selectedSwatch.getAttribute('data-variant-id');
  if (!selected_variant_id) return;

  const productPageLink = closestContainer.querySelector('a[id^="product-page-"]');
  if (productPageLink) {
    const baseUrl = productPageLink.href.split('?')[0];
    productPageLink.href = `${baseUrl}?variant=${selected_variant_id}`;
  }

  const product_form = closestContainer.querySelector('product-form');
  if (product_form) {
    const form = product_form.querySelector('form');
    const variantID = form?.querySelector('input[name="id"]');
    if (variantID) {
      variantID.setAttribute('value', selected_variant_id);
    }
  }

  // Today only product cards reach this function (quick-buy swatches go through getAllCheckedInputs);
  // updateQuickBuyButton() ignores anything outside a quick buy, so cards stay unchanged.
  if (closestContainer.closest('.js-quick-add-content')) {
    updateQuickBuyButton(closestContainer, findVariantInContainer(closestContainer, selected_variant_id));
  }
}

function getAllCheckedInputs(closestContainer, event){
  const AllProductInputForm = closestContainer.querySelectorAll('.product-form__input:not(.card-product-swatches)');
  if(AllProductInputForm.length > 0){
    var selectedValue = '';
    var selected_variant_id = '';
    var varaintTitle = [];
    AllProductInputForm.forEach((variant_selector, index)=>{
      if(variant_selector.querySelector('select')){
        var currentValue = '';
        if(index == 0 && variant_selector.querySelector('input[type="radio"]:checked')){
          currentValue = variant_selector.querySelector('input[type="radio"]:checked') ? variant_selector.querySelector('input[type="radio"]:checked').value : '';
          varaintTitle.push(currentValue);
        }else if(index == 0 && variant_selector.querySelector('select')){
          currentValue = variant_selector.querySelector('select') ? variant_selector.querySelector('select').value : '';
          varaintTitle.push(currentValue);
        } else{
          currentValue = variant_selector.querySelector('select') ? variant_selector.querySelector('select').value : '';
          varaintTitle.push(currentValue);          
        }
        if(variant_selector.querySelector('.cs_variant_value')) variant_selector.querySelector('.cs_variant_value').innerText = currentValue;
      }else{
        const currentValue = variant_selector.querySelector('input[type="radio"]:checked');
        if(currentValue){          
          varaintTitle.push(currentValue.value);
          if(variant_selector.querySelector('.cs_variant_value')) variant_selector.querySelector('.cs_variant_value').innerText = currentValue.value;
        }
      }
    })
    selectedValue = Array.from(varaintTitle).reduce((acc, curr) => acc + ' / ' + curr);
    // console.log('selectedValue: ', selectedValue);
    const allVariantJson = closestContainer.querySelector('.all_variant_json');
    var selectedVariant;
    if(allVariantJson){
      const allVariant = JSON.parse(allVariantJson.textContent);
      selectedVariant = allVariant.find(variant=> variant.title == selectedValue);
      if(selectedVariant){
        selected_variant_id = selectedVariant.id;
        const productPageLink = closestContainer.querySelector('a[id^="product-page-"]');
        if(productPageLink){
          const baseUrl = productPageLink.href.split('?')[0];
          productPageLink.href = `${baseUrl}?variant=${selected_variant_id}`;
        }
      }
    }
    const product_form = closestContainer.querySelector('product-form');
    if(product_form){
      const form = product_form.querySelector('form');
      const variantID = form.querySelector('input[name="id"]');
      if(variantID){
        variantID.setAttribute('value', selected_variant_id);
      }
    }
    if(allVariantJson) updateQuickBuyButton(closestContainer, selectedVariant);
  }
}

window.defaultColorSwatchSelected = function(opener, quickAddContainer){
  const closestWrapperContainer = opener.closest('.product-card-wrapper');
  if(closestWrapperContainer){
    const cardSwatches = closestWrapperContainer.querySelector('.card-product-swatches');
    if (cardSwatches) {
      const selectedSwatch =
        cardSwatches.querySelector('.cs_featured_collection_color_swatch.is-selected') ||
        cardSwatches.querySelector('.cs_featured_collection_color_swatch[aria-pressed="true"]');
      const selectedSwatchId = selectedSwatch?.getAttribute('data-variant-id');
      if (selectedSwatchId) {
        const quickPopUpvariant = quickAddContainer.querySelector(
          `input[type="radio"][data-variant-id="${selectedSwatchId}"]`
        );
        if (quickPopUpvariant) {
          const quickPopUpvariantId = quickPopUpvariant.getAttribute('id');
          const selectedInputrelatedLabel =
            quickAddContainer.querySelector(`label[for="${quickPopUpvariantId}"]`) ||
            quickPopUpvariant.closest('label');
          if (selectedInputrelatedLabel) {
            selectedInputrelatedLabel.click();
          }
        }
      }
      return;
    }

    const VariantSelectors = closestWrapperContainer.querySelectorAll('variant-selects-swatches');
    if(VariantSelectors.length > 0){
      VariantSelectors.forEach(variantSelector=>{
        const selectedInputSwtachs = variantSelector.querySelectorAll('input[type="radio"]');
        const selectedSwatch = Array.from(selectedInputSwtachs).find(input=> input.checked || input.hasAttribute('checked'));
        if(!selectedSwatch) return;
        const selectedSwatchId = selectedSwatch.getAttribute('data-variant-id');
        const quickPopUpvariant = quickAddContainer.querySelector(`input[type="radio"][data-variant-id="${selectedSwatchId}"]`);
        if(quickPopUpvariant){
          const quickPopUpvariantId = quickPopUpvariant.getAttribute('id');
          const selectedInputrelatedLabel = quickAddContainer.querySelector(`label[for="${quickPopUpvariantId}"]`)
            || quickPopUpvariant.closest('label');
          if(selectedInputrelatedLabel){
            selectedInputrelatedLabel.click();
          }
        }
      })
    }
  }
}


// Show More / Less Functionality in filter on collection page
window.showMoreLessFilter = function() {
  const allFilterLabels = document.querySelectorAll('facet-filters-form [data-filter-label]');
  
  if (allFilterLabels.length === 0) return;

  allFilterLabels.forEach(filterLabel => {
    const filterLabelText = filterLabel.getAttribute('data-filter-label');
    const closestSubMenu = filterLabel.closest('details');
    const showMoreLessBtn = closestSubMenu.querySelector('.js-show-more-less-button');
    const maxHeight = filterLabelText === 'farbe' ? 64 : 134;

    if (filterLabel.offsetHeight > maxHeight && showMoreLessBtn) {
      showMoreLessBtn.classList.remove('hidden');
    }

    filterLabel.style.cssText = `max-height: ${maxHeight}px; overflow-y: hidden;`;
  });
}

window.handleShowMoreLessButton = function() {
  const allShowMoreLessButtons = document.querySelectorAll('.js-show-more-less-button');

  if (allShowMoreLessButtons.length === 0) return;

  allShowMoreLessButtons.forEach(button => {
    const innerSpan = button.querySelector('.js-show-more-less-span');
    
    // Remove existing click event listener if any
    const newInnerSpan = innerSpan.cloneNode(true);
    innerSpan.parentNode.replaceChild(newInnerSpan, innerSpan);

    newInnerSpan.addEventListener('click', () => {
      // button.classList.contains('is--active') ? button.classList.remove('is--active') : button.classList.add('is--active');

      if(button.classList.contains('is--active')){
        button.classList.remove('is--active');
        newInnerSpan.innerText = `${window.facets.showMoreBtnText}`;
      }else{
        button.classList.add('is--active');
        newInnerSpan.innerText = `${window.facets.showLessBtnText}`;
      }
      const closestDetails = newInnerSpan.closest('details');
      const mobileFacetsSubmenu = closestDetails.querySelector('.mobile-facets__submenu');
      const mobileFacetsSubmenuInnerUL = closestDetails.querySelector('.mobile-facets__submenu [data-filter-label]');

      if (mobileFacetsSubmenu) {
        const maxHeight = mobileFacetsSubmenu.getAttribute('data-max-height');

        if (maxHeight) {
          mobileFacetsSubmenuInnerUL.style.cssText = button.classList.contains('is--active') 
            ? 'max-height: initial; overflow-y: hidden;' 
            : `max-height: ${maxHeight}px; overflow-y: hidden;`;
        }
      }
    });
  });
}


window.variantAddedQuickModel = function(response, quickAddModal){
  // console.log('response: ', response);
  // console.log('quickAddModal: ', quickAddModal);
  const variant_title = response.variant_title;
  const product_title = response.product_title;
  const varaint_price = response.presentment_price;
  const image_url = response.image;
  
  const quickModelVariantAddedEle = quickAddModal.querySelector('#quick-model-after-variant-added');
  if(quickModelVariantAddedEle){
    const quickModelVariantAddedContent = quickAddModal.querySelector('.quick-model-after-variant-added-content');
    if(quickModelVariantAddedEle){
      quickAddModal.setAttribute('open','');
      document.body.classList.add('js-overflow-hidden');
      if(quickAddModal.querySelector('.quick-add-modal__toggle')){
        quickAddModal.querySelector('.quick-add-modal__toggle').remove();
      }
      const cs_quick_buy_drawer_variant = quickModelVariantAddedContent.querySelector('.cs_quick_buy_drawer_variant');
      if(cs_quick_buy_drawer_variant){
        const image = cs_quick_buy_drawer_variant.querySelector('.cs_quick_buy_drawer_variant_image');
        if(image){
          image.src = image_url;
        }
        const variant_title_with_price = cs_quick_buy_drawer_variant.querySelector('.cs_variant_title_with_price');
        if(variant_title_with_price){
          const product_title_ele = variant_title_with_price.querySelector('.cs_product_title .cs_title');
          const cs_variant_price = variant_title_with_price.querySelector('.cs_product_title .cs_variant_price');
          const cs_variant_title = variant_title_with_price.querySelector('.cs_variant_title');
          if(product_title_ele){
            product_title_ele.innerText = product_title;
          }
          if(cs_variant_price){
            const currency = cs_variant_price.getAttribute('data-currency');
            cs_variant_price.innerText = currency + ' ' + varaint_price;
          }
          if(cs_variant_title){
            cs_variant_title.innerText = variant_title;
          }
        }
      }
      if(quickModelVariantAddedEle.classList.contains('hidden')){
        quickModelVariantAddedEle.classList.remove('hidden');
      }
      const cs_cart_button = quickModelVariantAddedContent.querySelector('.cartButton');
      if(cs_cart_button){
        cs_cart_button.addEventListener('click', ()=> {
          quickAddModal.removeAttribute('open');
          document.body.classList.add('js-overflow-hidden');
          document.querySelector('#cart-icon-bubble').click();
        });
      }
    }
  }

}


// Show more / less functionality in product media lists
const allProductMediaLists = document.querySelectorAll('.product_media_lists_show_more_buttons_container');

if (allProductMediaLists.length > 0) {
  allProductMediaLists.forEach(productMediaList => {
    const button = productMediaList.querySelector('.span_with_icon_wrapper');
    button.addEventListener('click', toggleProductMediaLists.bind(this));
  });
}

function toggleProductMediaLists(evt) {
  const currentTarget = evt.target;
  const productMediaListsContainer = currentTarget.closest('.product_media_lists_container');

  if (!productMediaListsContainer) return;

  const productMediaList = productMediaListsContainer.querySelector('.product__media-list');
  if (!productMediaList) return;

  const productMediaItems = productMediaList.querySelectorAll('.product__media-item');
  productMediaItems.forEach(productMediaItem => {
    const isAlwaysActive = productMediaItem.classList.contains('always-active');
    const isMatchedListItem = productMediaItem.classList.contains('matched_list_item');

    if (isAlwaysActive && isMatchedListItem) {
      productMediaItem.classList.toggle('js-is-hidden');
    } else if (!isAlwaysActive) {
      productMediaItem.classList.toggle('js-is-hidden');
    }
  });

  const innerSpan = currentTarget.querySelector('span');
  currentTarget.classList.toggle('is--active');
  innerSpan.innerText = currentTarget.classList.contains('is--active') 
    ? window.productMediaLists.showLessBtnText 
    : window.productMediaLists.showMoreBtnText;
}


// let _swiper = null;

// function initSwiperForMobile() {
//   if (window.innerWidth <= 768 && !_swiper) {
//     _swiper = new Swiper(".category-grid__slidertom", {
//       slidesPerView: 2.5,
//       spaceBetween: 10,
//       loop: false,
//     });
//   } else if (window.innerWidth > 768 && _swiper) {
//     _swiper.destroy(true, true);
//     _swiper = null;
//   }
// }

// window.addEventListener("load", initSwiperForMobile);
// window.addEventListener("resize", initSwiperForMobile);



document.addEventListener('DOMContentLoaded', function() {
  const faqQuestions = document.querySelectorAll('.faq-question');
  
  faqQuestions.forEach(question => {
    question.addEventListener('click', () => {
      const answer = question.nextElementSibling;
      const icon = question.querySelector('.icon');
      
      // Toggle answer visibility
      if (answer.style.display === 'block') {
        answer.style.display = 'none';
        if (icon.textContent === '−') {
          icon.textContent = '+';
        } else if (icon.textContent === '↑') {
          icon.textContent = '↓';
        }
      } else {
        answer.style.display = 'block';
        if (icon.textContent === '+') {
          icon.textContent = '−';
        } else if (icon.textContent === '↓') {
          icon.textContent = '↑';
        }
      }
    });
  });
}); 

// custom filter banner 
window.handleCustomFilterBanner = function(){
  if(document.querySelectorAll('.products-type').length > 0){
    document.querySelectorAll('.products-type').forEach(productTypeEl => {
        document.querySelectorAll('.category-item.active-filter').forEach(item => {
          item.classList.remove('active-filter');
        });
      productTypeEl.addEventListener('click', (e) => {
        document.querySelectorAll('.category-item.active-filter').forEach(item => {
          item.classList.remove('active-filter');
        });
        const categoryItem = productTypeEl.closest('.category-item');
        if (categoryItem) {
          categoryItem.classList.add('active-filter');
        }
        const current_product_type = e.target.closest('.products-type').dataset.handle.trim().toLowerCase();
        document.querySelectorAll('.mobile-facets__checkbox').forEach(input => {
          if (input.checked) {
            input.click(); 
          }
        });
        document.querySelectorAll('.mobile-facets__checkbox').forEach(input => {
          const inputValue = input.value.trim().toLowerCase();
          if (inputValue === current_product_type && !input.checked) {
            input.click();
          }
        });
      });
    });
  }
}
window.handleCustomFilterBanner();



/// product form progressbar
window.updateCustomQuantity = function () {
  function handleQuantity(currentTarget) {
    const quantity = currentTarget.value;
    const currentOptionPrice = currentTarget.getAttribute('option-price');
    const closestForm = currentTarget.closest('.product__info-wrapper');
    const closestBuyButton = closestForm?.querySelector('[data-button-price]');
    const quantityInput = closestForm?.querySelector("[name='quantity']");

    if (quantityInput) {
      quantityInput.value = quantity;
    }
    if (closestBuyButton) {
      closestBuyButton.innerText = currentOptionPrice + " " + Shopify.currency.active;
    }
  }
  const customQuantityRadios = document.querySelectorAll(".custom-quantity");
  customQuantityRadios.forEach((radio) => {
    radio.addEventListener("click", () => {
      handleQuantity(radio);
    });
  });
  const selectedQuantity = document.querySelector(".custom-quantity:checked");
  if (selectedQuantity) {
    handleQuantity(selectedQuantity);
  }
};
document.addEventListener("DOMContentLoaded", function () {
  window.updateCustomQuantity();
});
// custom-progressbar 
document.addEventListener('DOMContentLoaded', function() {
  const radios = document.querySelectorAll('.custom-quantity');
  const progressBar = document.getElementById('customProgressBar');
  const total = radios.length;
  function updateProgressBar() {
    let checkedIndex = 0;
    radios.forEach((radio, idx) => {
      if (radio.checked) checkedIndex = idx;
    });
    const percent = ((checkedIndex + 1) / total) * 100;
    if(progressBar) progressBar.style.width = percent + '%';
  }
  radios.forEach(radio => {
    radio.addEventListener('change', updateProgressBar);
    radio.addEventListener('click', updateProgressBar);
  });
  updateProgressBar();
});

////////////////
let flickityInstance = null;
let flickityInstanceForTabbings = null;

function initFlickitySlider(elem, options) {
  if (!elem.classList.contains('flickity-enabled')) {
    return new Flickity(elem, options);
  }
  return null;
}

function destroyFlickitySlider(instance) {
  if (instance) {
    instance.destroy();
    return null;
  }
  return instance;
}

// Custom image banner slider Javascript
function initOrDestroyBannerSlider() {
  const bannerSliders = document.querySelectorAll('.banner__media-slider');
  bannerSliders.forEach((elem) => {
    if (window.innerWidth <= 749) {
      flickityInstance = initFlickitySlider(elem, {
        cellAlign: 'center',
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        autoPlay: true
      });
    } else {
      flickityInstance = destroyFlickitySlider(flickityInstance);
    }
  });
}

// Featured Collection with Tabbings slider Javascript
let flickityTabbingInstances = [];
window.initOrDestroyTabbingSlider = function initOrDestroyTabbingSlider() {
  // Destroy all previous instances
  if (flickityTabbingInstances && flickityTabbingInstances.length > 0) {
    flickityTabbingInstances.forEach(instance => {
      if (instance) instance.destroy();
    });
    flickityTabbingInstances = [];
  }

  // Re-init all sliders
  const tabSliders = document.querySelectorAll('.js-featured-collection-tabs-slider');
  tabSliders.forEach((elem) => {
    if (!elem.classList.contains('flickity-enabled')) {
      const instance = new Flickity(elem, {
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        autoPlay: false
      });
      flickityTabbingInstances.push(instance);
    }
  });
}

initOrDestroyBannerSlider();
window.initOrDestroyTabbingSlider();

// Resize event listener
window.addEventListener('resize', () => {
  clearTimeout(window._bannerSliderTimeout);
  window._bannerSliderTimeout = setTimeout(initOrDestroyBannerSlider, 150);
});


const AllNavLists = document.querySelectorAll('nav.header__inline-menu');
if(AllNavLists.length > 0){
  AllNavLists.forEach(nav=>{
    const AllLi = nav.querySelectorAll('li');
    if(AllLi.length > 0){
      AllLi.forEach(list=>{
        const innerA = list.querySelector('a');
        innerA.addEventListener('mouseenter', ()=>{
          if(innerA) innerA.classList.add('header__active-menu-item');
        });
        innerA.addEventListener('mouseleave', ()=>{
          if(innerA) innerA.classList.remove('header__active-menu-item');
        });
      })
    }
  })
}


document.addEventListener('DOMContentLoaded', function () {
  // ------- Collection page banner slider --------
  const categoryGrid = document.querySelector('.category-grid.category-grid__slidertom');
   if (!categoryGrid) return;
  const categoryItems = Array.from(categoryGrid.querySelectorAll('.category-item'));

  categoryGrid.innerHTML = '';

  for (let i = 0; i < categoryItems.length; i += 2) {
    const cell = document.createElement('div');
    cell.classList.add('flickity-cell');

    cell.appendChild(categoryItems[i]);
    if (categoryItems[i + 1]) cell.appendChild(categoryItems[i + 1]);

    categoryGrid.appendChild(cell);
  }

  new Flickity(categoryGrid, {
    cellAlign: 'left',
    contain: true,
    pageDots: false,
    prevNextButtons: false,
    draggable: '>1',
    groupCells: false,
  });
});



window.initFlickityonPDPSwatches = function () {
  const productColorVariant = document.querySelectorAll(
    '.product .pro_variant_pick .product-form__input--color .product-form__input--color--flickity--slider'
  );

  if (productColorVariant.length > 0) {
    productColorVariant.forEach((variant) => {
      const variantLabel = variant.querySelectorAll('label');

      if (variantLabel.length > 4) {
        const flickitySlider = new Flickity(variant, {
          cellAlign: 'left',
          draggable: true,
          contain: true,
          wrapAround: false,
          pageDots: false,
          prevNextButtons: false // using custom buttons
        });

        const container = variant.closest('.product-form__input--color');
        const prevButton = container?.querySelector('.slider-button--prev');
        const nextButton = container?.querySelector('.slider-button--next');

        if (prevButton && nextButton) {
          prevButton.addEventListener('click', () => {
            flickitySlider.previous();
          });

          nextButton.addEventListener('click', () => {
            flickitySlider.next();
          });

          function updateArrowState() {
            prevButton.disabled = flickitySlider.selectedIndex === 0;
            nextButton.disabled = flickitySlider.selectedIndex === flickitySlider.slides.length - 1;
          }

          flickitySlider.on('change', updateArrowState);
          updateArrowState();
        }

        setTimeout(() => {
          variant.style.opacity = 1;
        }, 500);
      } else {
        variant.style.opacity = 1;
      }
    });
  }
};


window.initFlickityonPDPSwatches();

const bundle_product_list_flickity = document.querySelectorAll('.slider_wrap_main');
if(bundle_product_list_flickity.length > 0){
  bundle_product_list_flickity.forEach(slider=>{
    // Set height to 0 before initializing Flickity
    // slider.style.opacity = 0;
    
    const flickitySlider = new Flickity(slider, {
      contain: true,
      groupCells: 1,
      pageDots: true,
      prevNextButtons: false,
      autoPlay: false,
      on: {
        ready: function() {
          // Reset height after Flickity is initialized
          slider.style.opacity = 1;
        }
      }
    });
  });
}

// Bundle Products Add to Cart functionality.
window.handleBundleProducts = function(){
  const allBundleContainers = document.querySelectorAll('.js-bundle-container');
  if(allBundleContainers.length > 0){
    allBundleContainers.forEach(bundle_container=>{
      const addToCartButton = bundle_container.querySelector('.bundle-add-to-cart');
      if(addToCartButton){
        addToCartButton.addEventListener('click', ()=>{
          addBundleProductToCart(addToCartButton, bundle_container);
        });
      }
      const bundle_products = bundle_container.querySelectorAll('.bundle-product');
      if(bundle_products.length > 0){
        bundle_products.forEach((bundle_product, index)=>{
          const all_variant_selectors = bundle_product.querySelectorAll('.variant-select');
          if(all_variant_selectors.length > 0){
            all_variant_selectors.forEach((variant_selector)=>{
              variant_selector.addEventListener('change', ()=>{
                updateBundleVariant(variant_selector, bundle_product);
              });
            });
          }
        });
      }
    });
  }
}

function updateBundleVariant(variant_selector, bundle_product_container){
  var selectedValue = '';
  var selected_variant_id = '';
  var varaintTitle = [];
  const bundleProductImage = bundle_product_container.querySelector('.bundle-product-image');
  if(bundleProductImage){
    const innerImage = bundleProductImage.querySelector('img');
    if(innerImage && variant_selector.options[variant_selector.selectedIndex].hasAttribute('data-variant-image')){
      innerImage.src = variant_selector.options[variant_selector.selectedIndex]?.getAttribute('data-variant-image');
    }
  }
  // const current_variant_selector_value = variant_selector.value;
  const AllSelectedVariantValue = bundle_product_container.querySelectorAll('.variant-select');
  if(AllSelectedVariantValue.length > 0){
    AllSelectedVariantValue.forEach(selected_variant_value=>{
      varaintTitle.push(selected_variant_value.value);
    });
  }
  // selected_values.push(current_variant_selector_value);
  selectedValue = Array.from(varaintTitle).reduce((acc, curr) => acc + ' / ' + curr);

  const currentVariantJson = bundle_product_container.querySelector('.product_variants_json');
  // console.log(currentVariantJson);
  const bundleProductPrice = bundle_product_container.querySelector('.bundle-product-price');
  if(currentVariantJson){
    const allVariant = JSON.parse(currentVariantJson.textContent);
    const selectedVariant = allVariant.find(variant=> variant.title == selectedValue);
    if(selectedVariant){
      selected_variant_id = selectedVariant.id;
      if(bundleProductPrice) bundleProductPrice.setAttribute('value', selectedVariant.price);
    }

    // console.log(Shopify.formatMoney(selectedVariant.price, Shopify.money_format));
  }
  updateAddtoCartButtonState(selected_variant_id, variant_selector, bundle_product_container);
}

function updateAddtoCartButtonState(variant_id, variant_selector, bundle_product_container){
  const closestMainContainer = variant_selector.closest('.js-bundle-container');
  const allVariantSelectors = closestMainContainer.querySelectorAll('.variant-select');
  const addToCartButton = closestMainContainer.querySelector('.bundle-add-to-cart');
  const bundleProductPrice = bundle_product_container.querySelector('.bundle-product-price');
  const bundleProductPriceEle = closestMainContainer.querySelector('.discount-price');
  if (allVariantSelectors.length > 0) {
    const allSelectorsValid = Array.from(allVariantSelectors).every(selector => {
      return selector.value !== '' && selector.value !== null;
    });
    
    if(addToCartButton){
      allSelectorsValid ? addToCartButton.removeAttribute('disabled') : addToCartButton.setAttribute('disabled', true);
    }
    if(allSelectorsValid){
      const bundleProductPrices = closestMainContainer.querySelectorAll('.bundle-product-price');
      if(bundleProductPrices.length > 0){
        const totalPrice = Array.from(bundleProductPrices).reduce((acc, currentValue)=>{
          const currentPrice = Number(currentValue.value);
          return acc + currentPrice;
        }, 0);
        const discount_price = Number(bundleProductPrice?.getAttribute('data-discount-value') / 100.00);
        const minusPrice = discount_price * totalPrice;
        const final_price = totalPrice - minusPrice;
        
        // console.log(Shopify.formatMoney(final_price, Shopify.money_format));
        if(bundleProductPriceEle && final_price) bundleProductPriceEle.innerText = Shopify.formatMoney(final_price, Shopify.money_format);
      }
    }
  }
  if(!variant_id) return;
  const bundleProductIds = bundle_product_container.querySelector('.bundle-product-ids');
  if(bundleProductIds){
    bundleProductIds.value = variant_id;
  }
}

async function addBundleProductToCart(addToCartButton, closestMainContainer){
  // Disable the add to cart button while processing
  addToCartButton.setAttribute('disabled', true);
  addToCartButton.setAttribute('aria-busy', true);
  const itemsArray = [];
  const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  const bundleProductIds = closestMainContainer.querySelectorAll('.bundle-product-ids');
  if(bundleProductIds.length > 0){
    bundleProductIds.forEach(bundleProductId=>{
      itemsArray.push({
        id: bundleProductId.value,
        quantity: 1
      });
    });
  }
  console.log(itemsArray);
  if(itemsArray.length <= 0) return;
  const headers = { method: "POST", headers: {'Content-Type': 'application/json'}, body: JSON.stringify({items: itemsArray}) };
  const response = await fetch(`${window.Shopify.routes.root}cart/add.js?sections=${cart.getSectionsToRender().map((section) => section.id).join(",")}&sections_url=${window.location.pathname}`, headers);
  const data = await response.json();
  cart.renderContents(data, false);
  addToCartButton.removeAttribute('disabled');
  addToCartButton.removeAttribute('aria-busy');
  bundleProductIds.value = '';
}

window.handleBundleProducts();

const AllProductMediaSlider = document.querySelectorAll('.product--slider .product__media-list');
if(AllProductMediaSlider.length > 0){
  AllProductMediaSlider.forEach(slider=>{
    const flickitySlider = new Flickity(slider, {
      cellAlign: 'left',
      contain: true,
      pageDots: false,
      wrapAround: true,
      prevNextButtons: true,
      draggable: true,
      groupCells: 1,
      selectedAttraction: 0.01,
      friction: 0.15 
    });
  });
}

// Combo Products functionality.
const AllComboProducts = document.querySelectorAll('.js-combo-products-list');
if(AllComboProducts.length > 0){
  AllComboProducts.forEach(combo_products=>{
    const combo_product = combo_products.querySelectorAll('.js-combo-product');
    if(combo_product.length > 0){
      combo_product.forEach(product=>{
        const allColorItems = product.querySelectorAll('.js-color-swatch-item');
        const allSizeItems = product.querySelectorAll('.js-size-btn-item');
        if(allColorItems.length > 0){
          allColorItems.forEach(color_item=>{
            color_item.addEventListener('click', ()=>{
              updateComboProductVariant(color_item, product, true);
            });
          });
        }
        if(allSizeItems.length > 0){
          allSizeItems.forEach(size_item=>{
            size_item.addEventListener('click', ()=>{
             if(!size_item.classList.contains('disabled')) updateComboProductVariant(size_item, product, false);
            });
          });
        }        
      })
    }
    const AddToCartButton = combo_products.querySelector('.js-combo-add-to-cart-btn');
    if(AddToCartButton){
      AddToCartButton.addEventListener('click', ()=>{
        addComboProductToCart(combo_products);
      });
    }
  })
}

function updateComboProductVariant(currentTarget, combo_product_container, has_color_select) {
  const innerImage = combo_product_container.querySelector('.js-combo-product-image');
  const combo_product_id = combo_product_container.querySelector('.combo_product_id');
  const currentVariantLabel = currentTarget.getAttribute('data_variant_value');
  const allColorItems = combo_product_container.querySelectorAll('.js-color-swatch-item');
  const allSizeItems = combo_product_container.querySelectorAll('.js-size-btn-item');
  const current_product_json = combo_product_container.querySelector('.current_product_json');
  
  let current_product = {};
  if (current_product_json) {
    current_product = JSON.parse(current_product_json.textContent);
  }

  // Update image if available
  if (innerImage && currentTarget.hasAttribute('data_variant_image')) {
    innerImage.src = currentTarget.getAttribute('data_variant_image');
  }

  if (has_color_select) {
    handleSizeItems(current_product, currentVariantLabel, allSizeItems, combo_product_container);
  }

  updateSelectedItem(currentTarget, allColorItems, allSizeItems, currentVariantLabel, combo_product_container);
  
  const variantValueArray = Array.from(combo_product_container.querySelectorAll('.product-option .selected'))
    .map(item => item.getAttribute('data_variant_value'));

  const currentVariantName = variantValueArray.join(' / ');
  const variantDetail = current_product.variants.find(variant => variant.title === currentVariantName);
  
  if (variantDetail && variantDetail.available) {
    combo_product_id.setAttribute('value', variantDetail.id);
  }
}

function handleSizeItems(current_product, currentVariantLabel, allSizeItems, combo_product_container) {
  const selectedVariants = current_product.variants.filter(variant => variant.title.includes(currentVariantLabel));
  const unavailableVariants = selectedVariants.filter(variant => !variant.available);

  allSizeItems.forEach(size_item => size_item.classList.remove('disabled'));

  if (unavailableVariants.length > 0) {
    unavailableVariants.forEach(variant => {
      const index = selectedVariants.findIndex(v => v.id === variant.id);
      if (index !== -1 && allSizeItems[index]) {
        allSizeItems[index].classList.add('disabled');
      }
    });
  }

  const currentlySelectedSize = combo_product_container.querySelector('.js-size-btn-item.selected');
  if (currentlySelectedSize && currentlySelectedSize.classList.contains('disabled')) {
    // Only then find and select the first available size
    const firstAvailableSizeItem = Array.from(allSizeItems).find(sizeItem => !sizeItem.classList.contains('disabled'));
    if (firstAvailableSizeItem) {
      allSizeItems.forEach(size_item => size_item.classList.remove('selected'));
      firstAvailableSizeItem.classList.add('selected');
      combo_product_container.querySelector('.js-size-option-value').innerText = firstAvailableSizeItem.getAttribute('data_variant_value');
    }
  }
}

function updateSelectedItem(currentTarget, allColorItems, allSizeItems, currentVariantLabel, combo_product_container) {
  if (currentTarget.classList.contains('js-color-swatch-item')) {
    combo_product_container.querySelector('.js-color-option-value').innerText = currentVariantLabel;
    allColorItems.forEach(color_item => color_item.classList.remove('selected'));
    currentTarget.classList.add('selected');
  } else if (currentTarget.classList.contains('js-size-btn-item')) {
    combo_product_container.querySelector('.js-size-option-value').innerText = currentVariantLabel;
    allSizeItems.forEach(size_item => size_item.classList.remove('selected'));
    currentTarget.classList.add('selected');
  }
}


async function addComboProductToCart(main_container){
  const AddToCartButton = main_container.querySelector('.js-combo-add-to-cart-btn');
  AddToCartButton.setAttribute('disabled', true);
  AddToCartButton.setAttribute('aria-busy', true);
  let itemsArray = [];
  const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  const combo_product_id = main_container.querySelectorAll('.combo_product_id');
  if(combo_product_id.length > 0){
    combo_product_id.forEach(item=>{
      itemsArray.push({
        id: item.value,
        quantity: 1
      });
    });
  }

  if(itemsArray.length <= 0) return;
  const headers = { method: "POST", headers: {'Content-Type': 'application/json'}, body: JSON.stringify({items: itemsArray}) };
  const response = await fetch(`${window.Shopify.routes.root}cart/add.js?sections=${cart.getSectionsToRender().map((section) => section.id).join(",")}&sections_url=${window.location.pathname}`, headers);
  const data = await response.json();
  cart.renderContents(data, false);
  AddToCartButton.removeAttribute('disabled');
  AddToCartButton.removeAttribute('aria-busy');  
}


window.productUpdateImage = function(target, currentOption) {
  // console.log(currentOption);
  if(currentOption == 'color' || currentOption == 'colour' || currentOption == 'farbe'){    
    const selectedValue = target.toLowerCase();
    const mediaImages = document.querySelectorAll('.product__media[data-image-alt]');
    const productMediaItems = document.querySelectorAll('.product__media-item');
    const productThumbnailsMediaItems = document.querySelectorAll('.thumbnail-list__item[data-thumbnail-alt-tag]');
    const MAX_VISIBLE_ITEMS = 3;
    productMediaItems.forEach(item => item.classList.add('hidden'));
    productThumbnailsMediaItems.forEach(item => item.classList.add('hidden'));

    mediaImages.forEach(image => {
      const imageAlt = image.getAttribute('data-image-alt').toLowerCase();
      if (imageAlt.includes('color/') || imageAlt.includes('colour/') || imageAlt.includes('farbe/')) {
        const firstAttribute = imageAlt.split('/')[0];
        const targetImageAlt = `${firstAttribute}/${selectedValue}`;
        // console.log(imageAlt, " == ", targetImageAlt) 
        if (imageAlt == targetImageAlt) {
            image.closest('.product__media-item').classList.remove('hidden');
        }
      }
    });
    productThumbnailsMediaItems.forEach(image => {
      const imageAlt = image.getAttribute('data-thumbnail-alt-tag').toLowerCase();
      if (imageAlt.includes('color/') || imageAlt.includes('colour/') || imageAlt.includes('farbe/')) {
        const firstAttribute = imageAlt.split('/')[0];
        const targetImageAlt = `${firstAttribute}/${selectedValue}`;
        if (imageAlt == targetImageAlt) {
            image.classList.remove('hidden');
        }
      }
    });

    const visibleMediaItems = Array.from(productMediaItems).filter(item => !item.classList.contains('hidden'));
    const visibleCount = visibleMediaItems.length;

    visibleMediaItems.forEach((item, index) => {
      if (index > MAX_VISIBLE_ITEMS - 1 && item.classList.contains('template--budnle-product')) {
          item.classList.add('js-is-hidden', 'matched_list_item');
      }
    });

    const mediaListsContainer = document.querySelector('.product_media_lists_container');
    if (mediaListsContainer) {
      const showMoreLessButton = mediaListsContainer.querySelector('.product_media_lists_show_more_buttons_container');
      if (showMoreLessButton) {
          showMoreLessButton.classList.toggle('hidden', visibleCount <= MAX_VISIBLE_ITEMS);
      }
    }
  }
}



// B2B popup js start here 
document.addEventListener("DOMContentLoaded", function () {
  const showMoreBtn = document.querySelector('.js-b2b-show-more-btn');
  const popup = document.querySelector('.customb2b__popup');
  const closeIcon = document.querySelector('.closeicon');
  const Cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

  // Function to show popup
  function showPopup() {
    popup?.classList.add('b2bpopup-active');
    document.body.classList.add('b2bpopup-active');
  }

  // Function to hide popup
  function hidePopup() {
    popup?.classList.remove('b2bpopup-active');
    document.body.classList.remove('b2bpopup-active');
  }

  // Show popup on button click
  showMoreBtn?.addEventListener('click', function (e) {
    e.stopPropagation(); // Prevents it from triggering document click
    showPopup();
  });

  // Close on close icon
  closeIcon?.addEventListener('click', function (e) {
    e.stopPropagation();
    hidePopup();
  });

  // Close on outside click
  document.addEventListener('click', function (e) {
    const isClickInsidePopup = popup?.contains(e.target);
    const isClickOnButton = showMoreBtn?.contains(e.target);
    const isClickOnCart = Cart?.contains(e.target);

    if (!isClickInsidePopup && !isClickOnButton  && !isClickOnCart) {
      hidePopup();
    }
  });

   const slider = document.querySelector('.drag-scroll');
let isDown = false;
let startX;
let scrollLeft;

slider?.addEventListener('mousedown', (e) => {
  isDown = true;
  slider.classList.add('active');
  startX = e.pageX - slider.offsetLeft;
  scrollLeft = slider.scrollLeft;
});

slider?.addEventListener('mouseleave', () => {
  isDown = false;
  slider.classList.remove('active');
});

slider?.addEventListener('mouseup', () => {
  isDown = false;
  slider.classList.remove('active');
});

slider?.addEventListener('mousemove', (e) => {
  if (!isDown) return;
  e.preventDefault();
  const x = e.pageX - slider.offsetLeft;
  const walk = (x - startX) * 1; // scroll speed
  slider.scrollLeft = scrollLeft - walk;
});

// Color card selection – show details for all selected colors
const colorSection = popup?.querySelector('.customb2b-color-section');
const colorCardList = popup?.querySelector('.customb2b-color-card-list');
const colorDetailsTemplate = popup?.querySelector('.customb2b-color-details-wrapper');
const colorCards = popup?.querySelectorAll('.js-b2b-color-card');
const colorRows = popup?.querySelectorAll('.customb2b__inneritem.productinnerdata');
const colorNames = popup?.querySelectorAll('.customb2b__innertableleft .b2bproductname');
const colorDetailsClose = colorDetailsTemplate?.querySelector('.customb2b-color-details-close');

function isDesktopB2BPopup() {
  return window.matchMedia('(min-width: 750px)').matches;
}

function showB2BColorPanel(scope, indexStr, quantityByVariantId = {}) {
  if (!scope) return;
  const table = scope.querySelector('[data-b2b-variant-table]');
  if (!table) return;

  const panels = table.querySelectorAll('.b2b-color-size-panel');
  let activePanel = null;

  panels.forEach((panel) => {
    const matches = String(panel.getAttribute('data-b2b-color-index')) === String(indexStr);
    panel.hidden = !matches;
    panel.classList.toggle('is-active', matches);
    if (matches) activePanel = panel;
  });

  if (!activePanel) return;

  activePanel.querySelectorAll('.js-variant-input-details').forEach((variantRow) => {
    const variantIdInput = variantRow.querySelector('input[name="input_variant_id"]');
    const qtyInput = variantRow.querySelector('.b2bquantity');
    const variantId = variantIdInput ? String(variantIdInput.value) : '';
    if (!variantId || !qtyInput) return;
    const savedQty = quantityByVariantId[variantId];
    if (savedQty !== undefined && savedQty !== null) {
      qtyInput.value = String(savedQty);
    }
  });
}

function activateB2BColorRows(scope, indexStr, quantityByVariantId = {}) {
  if (!scope) return;
  showB2BColorPanel(scope, indexStr, quantityByVariantId);
}

function syncB2BHeaderDataFromRow(row, scope = popup, quantityByVariantId = {}) {
  if (!scope) return;
  const indexStr =
    row?.getAttribute?.('data-b2b-color-index') ||
    scope.getAttribute('data-b2b-color-index');
  if (indexStr === null || indexStr === undefined) return;
  activateB2BColorRows(scope, indexStr, quantityByVariantId);
}

function getColorCardByIndex(indexStr) {
  return Array.from(colorCards || []).find(
    (card) => card.getAttribute('data-b2b-color-index') === indexStr
  );
}

function insertDetailsAfterRow(detailsWrapper, selectedCard) {
  if (!colorCardList || !selectedCard) return;
  const allCards = Array.from(colorCardList.querySelectorAll('.js-b2b-color-card'));
  const selectedTop = selectedCard.offsetTop;
  let lastInRow = selectedCard;

  allCards.forEach((card) => {
    if (card.offsetTop === selectedTop && card.offsetLeft > lastInRow.offsetLeft) {
      lastInRow = card;
    }
  });

  let insertionPoint = lastInRow.nextElementSibling;
  while (insertionPoint && insertionPoint.classList.contains('customb2b-color-details-wrapper')) {
    insertionPoint = insertionPoint.nextElementSibling;
  }

  if (insertionPoint) {
    colorCardList.insertBefore(detailsWrapper, insertionPoint);
  } else {
    colorCardList.appendChild(detailsWrapper);
  }
}

function createColorDetailsWrapper(indexStr, selectedCard, quantityByVariantId = {}) {
  if (!colorDetailsTemplate || !selectedCard) return null;

  const detailsWrapper = colorDetailsTemplate.cloneNode(true);
  detailsWrapper.classList.add('is-active');
  detailsWrapper.setAttribute('data-b2b-color-index', indexStr);
  detailsWrapper.setAttribute('data-b2b-generated', 'true');

  const titleEl = selectedCard.querySelector('.b2b-color-card__title');
  const codeEl = selectedCard.querySelector('.b2b-color-card__code');
  const circleEl = selectedCard.querySelector('.b2b-color-card__circle');
  const titleTarget = detailsWrapper.querySelector('.customb2b-color-details-title');
  const codeTarget = detailsWrapper.querySelector('.customb2b-color-details-code');
  const circleTarget = detailsWrapper.querySelector('.customb2b-color-details-circle');

  if (titleEl && titleTarget) titleTarget.textContent = titleEl.textContent.trim();
  if (codeEl && codeTarget) codeTarget.textContent = codeEl.textContent.trim();
  if (circleEl && circleTarget && circleEl.style.backgroundColor) {
    circleTarget.style.backgroundColor = circleEl.style.backgroundColor;
  }

  showB2BColorPanel(detailsWrapper, indexStr, quantityByVariantId);

  const closeButton = detailsWrapper.querySelector('.customb2b-color-details-close');
  closeButton?.addEventListener('click', (e) => { 
    e.preventDefault();
    e.stopPropagation();
    const cardToToggle = getColorCardByIndex(indexStr);
    if (cardToToggle) cardToToggle.classList.remove('is-active');
    detailsWrapper.remove();
  });

  if (window.bindB2BQuantityInputs && window.b2bData) {
    window.bindB2BQuantityInputs(detailsWrapper, popup, window.b2bData);
  }

  return detailsWrapper;
}

function renderActiveColorDetails() {
  if (!colorCardList) return;

  const quantityByVariantId = {};
  popup?.querySelectorAll('.js-variant-input-details').forEach((variantRow) => {
    const panel = variantRow.closest('.b2b-color-size-panel');
    if (panel && panel.hidden) return;
    const variantIdInput = variantRow.querySelector('input[name="input_variant_id"]');
    const qtyInput = variantRow.querySelector('.b2bquantity');
    if (!variantIdInput || !qtyInput) return;
    const variantId = String(variantIdInput.value);
    const quantity = parseInt(qtyInput.value, 10) || 0;
    if (variantId && quantity > 0) {
      quantityByVariantId[variantId] = quantity;
    }
  });

  colorCardList
    .querySelectorAll('.customb2b-color-details-wrapper[data-b2b-generated="true"]')
    .forEach((el) => el.remove());

  const activeCards = Array.from(colorCards || []).filter((card) =>
    card.classList.contains('is-active')
  );

  activeCards.forEach((card) => {
    const indexStr = String(card.getAttribute('data-b2b-color-index'));
    const detailsWrapper = createColorDetailsWrapper(indexStr, card, quantityByVariantId);
    if (detailsWrapper) insertDetailsAfterRow(detailsWrapper, card);
  });

  if (window.b2bData && popup) {
    const firstVariant = popup.querySelector('.js-variant-input-details');
    if (firstVariant) {
      updateQuantity(
        window.b2bData,
        firstVariant,
        popup.querySelectorAll('.js-variant-input-details'),
        popup
      );
    }
  }
}

function renderSingleColorDetails(indexStr, selectedCard) {
  if (!colorDetailsTemplate || !selectedCard || !colorCardList) return;

  colorCards?.forEach((card) => {
    card.classList.toggle('is-active', card.getAttribute('data-b2b-color-index') === indexStr);
  });

  const titleEl = selectedCard.querySelector('.b2b-color-card__title');
  const codeEl = selectedCard.querySelector('.b2b-color-card__code');
  const circleEl = selectedCard.querySelector('.b2b-color-card__circle');
  const titleTarget = colorDetailsTemplate.querySelector('.customb2b-color-details-title');
  const codeTarget = colorDetailsTemplate.querySelector('.customb2b-color-details-code');
  const circleTarget = colorDetailsTemplate.querySelector('.customb2b-color-details-circle');

  if (titleEl && titleTarget) titleTarget.textContent = titleEl.textContent.trim();
  if (codeEl && codeTarget) codeTarget.textContent = codeEl.textContent.trim();
  if (circleEl && circleTarget && circleEl.style.backgroundColor) {
    circleTarget.style.backgroundColor = circleEl.style.backgroundColor;
  }

  colorDetailsTemplate.classList.add('is-active');
  colorDetailsTemplate.setAttribute('data-b2b-color-index', indexStr);
  insertDetailsAfterRow(colorDetailsTemplate, selectedCard);

  showB2BColorPanel(colorDetailsTemplate, indexStr);

  if (window.bindB2BQuantityInputs && window.b2bData) {
    window.bindB2BQuantityInputs(colorDetailsTemplate, popup, window.b2bData);
  }
}

function selectB2BColorByIndex(index) {
  if (!popup || index === null || index === undefined) return;
  const indexStr = String(index);
  const selectedCard = getColorCardByIndex(indexStr);
  if (!selectedCard) return;

  if (!isDesktopB2BPopup()) {
    colorCardList
      ?.querySelectorAll('.customb2b-color-details-wrapper[data-b2b-generated="true"]')
      .forEach((el) => el.remove());
    renderSingleColorDetails(indexStr, selectedCard);
    return;
  }

  selectedCard.classList.toggle('is-active');
  renderActiveColorDetails();
}


colorCards?.forEach(card => {
  card.addEventListener('click', (e) => {
    e.preventDefault();
    const index = card.getAttribute('data-b2b-color-index');
    selectB2BColorByIndex(index);
  });
});

// Do not preselect any color; details stay hidden until a click

if (colorDetailsTemplate && isDesktopB2BPopup()) {
  colorDetailsTemplate.remove();
}

colorDetailsClose?.addEventListener('click', (e) => {
  if (isDesktopB2BPopup()) return;
  e.preventDefault();
  e.stopPropagation();
  colorDetailsTemplate?.classList.remove('is-active');
  colorDetailsTemplate
    ?.querySelectorAll(
      '.customb2b__inneritem.headerdata, .customb2b__inneritem.headerprice, .customb2b__inneritem.rowstock, .customb2b__inneritem.productinnerdata, .b2bproductname'
    )
    .forEach((el) => el.classList.remove('is-active'));
  colorCards?.forEach(card => card.classList.remove('is-active'));
});
});


function handleB2BCustomersPopup() {
const data = {
  variants: [],
};
const popup = document.querySelectorAll('.customb2b__popup');

function bindB2BQuantityInputs(scope, mainPopup, b2bData) {
  const variantInputDetails = scope.querySelectorAll('.js-variant-input-details');
  if (variantInputDetails.length <= 0) return;

  variantInputDetails.forEach(variantInputDetail=>{
    const inputQuantity = variantInputDetail.querySelector('.b2bquantity');
    if(inputQuantity && !inputQuantity.hasAttribute('data-b2b-qty-bound')){
      inputQuantity.setAttribute('data-b2b-qty-bound', 'true');
      // Validate input to only allow numbers
      inputQuantity.addEventListener('input', (e)=>{
        const value = e.target.value;
        if(!(value === '' || /^\d+$/.test(value))) {
          e.target.value = e.target.value.replace(/\D/g, '') || '0';
        }
        updateQuantity(
          b2bData,
          variantInputDetail,
          mainPopup.querySelectorAll('.js-variant-input-details'),
          mainPopup
        );
      });

      // Handle paste events
      inputQuantity.addEventListener('paste', (e)=>{
        setTimeout(() => {
          const value = e.target.value;
          e.target.value = value.replace(/\D/g, '') || '0';
          updateQuantity(
            b2bData,
            variantInputDetail,
            mainPopup.querySelectorAll('.js-variant-input-details'),
            mainPopup
          );
        }, 0);
      });
    }
  });
}

window.bindB2BQuantityInputs = bindB2BQuantityInputs;
if(popup.length > 0){
  popup.forEach(_popup=>{
    bindB2BQuantityInputs(_popup, _popup, data);
    if (!_popup.hasAttribute('data-b2b-delegated-qty-bound')) {
      _popup.setAttribute('data-b2b-delegated-qty-bound', 'true');

      _popup.addEventListener('input', (e) => {
        const input = e.target;
        if (!(input instanceof HTMLInputElement) || !input.classList.contains('b2bquantity')) return;
        if (input.value !== '' && !/^\d+$/.test(input.value)) {
          input.value = input.value.replace(/\D/g, '') || '0';
        }
        const detail = input.closest('.js-variant-input-details');
        if (detail) {
          updateQuantity(data, detail, _popup.querySelectorAll('.js-variant-input-details'), _popup);
        }
      });

      _popup.addEventListener('change', (e) => {
        const input = e.target;
        if (!(input instanceof HTMLInputElement) || !input.classList.contains('b2bquantity')) return;
        const detail = input.closest('.js-variant-input-details');
        if (detail) {
          updateQuantity(data, detail, _popup.querySelectorAll('.js-variant-input-details'), _popup);
        }
      });
    }
  })
}

window.b2bData = data;
}

handleB2BCustomersPopup();

function updateQuantity(data, variantInputDetail, variantInputDetailsWrapper, mainWrapper){
let totalQuantity = 0;
let updatedVariants = [];
const footerGroup = mainWrapper.querySelector('.customb2b-footergroup');

if(variantInputDetailsWrapper.length > 0){
  const variantMap = {};

  Array.from(variantInputDetailsWrapper).forEach((curr) => {
    const panel = curr.closest('.b2b-color-size-panel');
    if (panel && panel.hidden) return;

    const colorRow = curr.closest('.customb2b__inneritem.productinnerdata');
    if (colorRow && !colorRow.classList.contains('is-active')) return;

    const inputQuantity = curr.querySelector('.b2bquantity');
    const quantity = inputQuantity ? (parseInt(inputQuantity.value) || 0) : 0;
    if (quantity <= 0) return;

    const productVariantsJson = curr.querySelector('.product_variants_json');
    if (!productVariantsJson) return;

    try {
      const variantJson = JSON.parse(productVariantsJson.textContent);
      if (!variantJson || !variantJson.variant_id) return;

      if (!variantMap[variantJson.variant_id]) {
        variantMap[variantJson.variant_id] = { ...variantJson, quantity: 0 };
      }
      variantMap[variantJson.variant_id].quantity += quantity;
    } catch (error) {
      console.error('Invalid B2B variant JSON', error);
    }
  });

  updatedVariants = Object.values(variantMap);
  totalQuantity = updatedVariants.reduce((acc, curr) => acc + (curr.quantity || 0), 0);
}

data.variants = updatedVariants;

// Ensure totalQuantity is never NaN
totalQuantity = isNaN(totalQuantity) ? 0 : totalQuantity;

if(footerGroup){
  const itemCountWrapper = footerGroup.querySelector('.itemCountWrapper');
  const AddToCartButton = footerGroup.querySelector('.js-customb2b-addtocart-all');
  if(itemCountWrapper){
    const itemCount = itemCountWrapper.querySelector('.itemcount');
    if(itemCount) {
      // Ensure totalQuantity is always a valid number
      const displayQuantity = isNaN(totalQuantity) ? 0 : totalQuantity;
      itemCount.innerText = displayQuantity;
    }
  }
  if(AddToCartButton){
    if(totalQuantity > 0){
      AddToCartButton.removeAttribute('disabled');
    } else {
      AddToCartButton.setAttribute('disabled', true);
    }
    // AddToCartButton.addEventListener('click', ()=>{
    //   addB2BProductToCart(footerGroup, data);
    // });
  }
}
  
renderPrice(data, footerGroup);
}

const newPopup = document.querySelector('.customb2b__popup');
const newFooterGroup = newPopup?.querySelector('.customb2b-footergroup');
const newAddToCartButton = newFooterGroup?.querySelector('.js-customb2b-addtocart-all');
if(newFooterGroup && newAddToCartButton){
newAddToCartButton.addEventListener('click', ()=>{
  addB2BProductToCart(newFooterGroup, window.b2bData);
});
}


function renderPrice(data, footerGroup){
let totalPrice = 0;

totalPrice = data.variants.reduce((sum, variant) => {
  const variantTotal = (variant.price * (variant.quantity || 0));
  return sum + variantTotal;
}, 0);
  
if(footerGroup){
  const totalPriceElement = footerGroup.querySelector('.amount');
  if(totalPriceElement) {
    totalPriceElement.textContent = Shopify.formatMoney(totalPrice, Shopify.money_format);
  }
}
}

function resetPopup(footerGroup){
const mainWrapper = footerGroup.closest('.customb2b__popup');
const itemCountWrapper = footerGroup.querySelector('.itemCountWrapper');
const totalPriceWrapper = footerGroup.querySelector('.amount');
const AddToCartButton = footerGroup.querySelector('.js-customb2b-addtocart-all');
const errorElement = footerGroup.querySelector('.js-customb2b-error');
if(errorElement){
  errorElement.textContent = '';
  errorElement.hidden = true;
}
if(mainWrapper){
  const variantInputDetails = mainWrapper.querySelectorAll('.js-variant-input-details');
  if(variantInputDetails.length > 0){
    variantInputDetails.forEach(variantInputDetail=>{
      const inputQuantity = variantInputDetail.querySelector('.b2bquantity');
      if(inputQuantity) inputQuantity.value = '0';
    });
  }
  const data = {
    variants: [],
  };
  if(itemCountWrapper){
    const itemCount = itemCountWrapper.querySelector('.itemcount');
    if(itemCount) itemCount.innerText = '0';
  }
  if(AddToCartButton){
    AddToCartButton.setAttribute('disabled', true);
  }
  if(totalPriceWrapper){
    totalPriceWrapper.innerText = Shopify.formatMoney(0, Shopify.money_format);
  }
  mainWrapper.classList.remove('b2bpopup-active');
  document.body.classList.remove('b2bpopup-active');
}

}

async function addB2BProductToCart(footerGroup, data){
const addToCartButton = footerGroup.querySelector('.js-customb2b-addtocart-all');
const errorElement = footerGroup.querySelector('.js-customb2b-error');
const showError = (message) => {
  if(!errorElement) return;
  errorElement.textContent = message || '';
  errorElement.hidden = !message;
};
showError('');
if(addToCartButton){
  addToCartButton.setAttribute('disabled', true);
  addToCartButton.setAttribute('aria-busy', true);
}
const items = data.variants.map((p) => ({ id: p.variant_id, quantity: p.quantity }));
const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
const sectionIds = cart && typeof cart.getSectionsToRender === 'function'
  ? cart.getSectionsToRender().map((section) => section.id)
  : [];
const sectionsQuery = sectionIds.length
  ? `?sections=${sectionIds.join(',')}&sections_url=${window.location.pathname}`
  : '';
const fallbackError = (window.cartStrings && window.cartStrings.error) || 'Error';
let responseData = null;
let errorMessage = '';
try {
  const response = await fetch(`${root}cart/add.js${sectionsQuery}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items }),
  });
  responseData = await response.json();
  if (!response.ok || responseData.status) {
    // Shopify answers 422 e.g. when a quantity exceeds the sellable stock.
    errorMessage = responseData.description || responseData.message || fallbackError;
  }
} catch (error) {
  console.error('B2B add to cart failed', error);
  errorMessage = fallbackError;
}

if (cart && sectionIds.length) {
  let sectionsData = responseData && responseData.sections ? responseData : null;
  if (!sectionsData) {
    // Shopify may have added part of the selection even when it rejected the
    // request, so refresh the drawer from the current cart state.
    try {
      const sectionsResponse = await fetch(`${root}?sections=${sectionIds.join(',')}`);
      sectionsData = { sections: await sectionsResponse.json() };
    } catch (error) {
      console.error('Cart sections refresh failed', error);
    }
  }
  if (sectionsData && sectionsData.sections) {
    try {
      cart.renderContents(sectionsData, Boolean(errorMessage));
    } catch (error) {
      console.error('Cart render failed', error);
    }
  }
}

if(addToCartButton){
  addToCartButton.removeAttribute('disabled');
  addToCartButton.removeAttribute('aria-busy');
}
if (errorMessage) {
  showError(errorMessage);
  return;
}
setTimeout(()=> resetPopup(footerGroup), 500);
}

function getCurrentVariants() {
return window.b2bData ? window.b2bData.variants : [];
}

function getVariantById(variantId) {
const variants = getCurrentVariants();
return variants.find(variant => variant.variant_id === variantId);
}

function getTotalQuantity() {
const variants = getCurrentVariants();
return variants.reduce((total, variant) => total + (variant.quantity || 0), 0);
}

function getTotalPrice() {
const variants = getCurrentVariants();
return variants.reduce((total, variant) => total + (variant.price * (variant.quantity || 0)), 0);
}

// Export functions for global access
window.getCurrentVariants = getCurrentVariants;
window.getVariantById = getVariantById;
window.getTotalQuantity = getTotalQuantity;
window.getTotalPrice = getTotalPrice;

// ===== Accurate Table-wise Height Calculation =====
(function () {

  function updateAllTables() {
    const detailWrappers = document.querySelectorAll(".customb2b-color-details-wrapper");

    detailWrappers.forEach(wrapper => {

      const tableWrapper = wrapper.querySelector(".customb2b__innnertabledatawrapper");
      if (!tableWrapper) return;

      // 👉 target REAL content elements (NOT wrapper)
      const cells = wrapper.querySelectorAll(
        ".customb2b__inneritem.rowstock .b2bstock, \
         .customb2b__inneritem.headerprice .customb2b__popuptableprice"
      );

      if (!cells.length) return;

      let maxHeight = 0;

      cells.forEach(el => {
        const height = el.getBoundingClientRect().height; // ✅ more accurate
        if (height > maxHeight) {
          maxHeight = height;
        }
      });

      // Apply per table
      tableWrapper.style.setProperty(
        "--rowstockwrappermaxheight",
        `${Math.ceil(maxHeight)}px`
      );

      console.log("✅ Correct Height:", maxHeight);
    });
  }

  function safeUpdate() {
    requestAnimationFrame(() => {
      requestAnimationFrame(updateAllTables);
    });
  }

  // Initial
  setTimeout(safeUpdate, 300);

  // Observe DOM changes
  const observer = new MutationObserver(safeUpdate);
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  window.addEventListener("resize", safeUpdate);

})();